<template>
  <footer></footer>
</template>

<script>
export default {
  name: 'PageFoot',
}
</script>

<style scoped>
footer {
  height: 24px;
  width: 100%;
  background-color: transparent;
}
</style>
